import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Spinner,
  Text,
  VStack,
  Divider,
  Button,
} from "@chakra-ui/react";
import { getNotificationHistory } from "../services/pushNotificationService";

const PAGE_SIZE = 20;

const TechNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  // Initial fetch
  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const data = await getNotificationHistory(PAGE_SIZE, 0);
        setNotifications(data);
        setOffset(data.length);
        setHasMore(data.length === PAGE_SIZE);
      } catch (error) {
        setNotifications([]);
        setHasMore(false);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  // Load more handler
  const handleLoadMore = async () => {
    setLoadingMore(true);
    try {
      const data = await getNotificationHistory(PAGE_SIZE, offset);
      setNotifications((prev) => [...prev, ...data]);
      setOffset((prev) => prev + data.length);
      setHasMore(data.length === PAGE_SIZE);
    } catch (error) {
      setHasMore(false);
    } finally {
      setLoadingMore(false);
    }
  };

  return (
    <Box maxW="600px" mx="auto" mt={8} p={4}>
      <Heading size="lg" mb={6} textAlign="center">
        Notification History
      </Heading>
      {loading ? (
        <Box textAlign="center" py={12}>
          <Spinner size="lg" color="teal.500" />
        </Box>
      ) : notifications.length === 0 ? (
        <Text color="gray.500" textAlign="center">
          No notifications found.
        </Text>
      ) : (
        <>
          <VStack align="stretch" spacing={4}>
            {notifications.map((notif, idx) => (
              <Box
                key={notif._id || idx}
                p={4}
                borderWidth={1}
                borderRadius="md"
                bg="white"
                boxShadow="sm"
              >
                <Text fontWeight="bold">{notif.title || "Notification"}</Text>
                <Text fontSize="sm" color="gray.600" mt={1}>
                  {notif.message || notif.body || "No details available."}
                </Text>
                <Text fontSize="xs" color="gray.400" mt={2}>
                  {notif.createdAt
                    ? new Date(notif.createdAt).toLocaleString()
                    : ""}
                </Text>
                {idx !== notifications.length - 1 && <Divider mt={3} />}
              </Box>
            ))}
          </VStack>
          {hasMore && (
            <Box textAlign="center" mt={6}>
              <Button
                onClick={handleLoadMore}
                isLoading={loadingMore}
                loadingText="Loading..."
                colorScheme="teal"
                variant="outline"
                size="md"
              >
                Load more
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default TechNotifications;
